import GroupOrders from './GroupOrders'

export default GroupOrders
